import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { isUndefined } from "../../FunctionsCore";
import { filterOutUndefineds } from "../../Internal";
import { classCombinerFromPrefix, renderIdentifierGeneric } from "../../RenderIdentifier";
import ContactProfileRelatedIndustriesFragmentStyles from "./ContactProfileRelatedIndustriesFragmentStyles.module.scss";
const styles = ContactProfileRelatedIndustriesFragmentStyles;
const classCombiner = classCombinerFromPrefix("1e26942de2d098dd");
const ContactProfileRelatedIndustriesFragmentComponent = (props) => {
    const { contactDirectoryIndustryData } = props;
    const { contactProfilePageData, industryByNaicsTwoTyped, industryNaicsByTitleTyped, industryNameByNaicsTyped, industryTitleUrlRewrittenLookup, } = contactDirectoryIndustryData;
    // TODO "!"
    const { industryNaicsFourCodes } = contactProfilePageData;
    const industryNaicsFourCodesLength = industryNaicsFourCodes.length;
    // TODO Find better alternative to counter and flatMap technique
    let naicsTwoCount = 0;
    const contentNaicsTwoCode = industryNaicsFourCodes.flatMap((st) => {
        const naicsTwoCode = st.slice(0, 2);
        const naicsTwoTitle = industryNameByNaicsTyped[naicsTwoCode];
        if (isUndefined(naicsTwoTitle)) {
            return [];
        }
        const naicsTwoChildTitles = industryByNaicsTwoTyped[naicsTwoTitle];
        const naicsFourTitle = industryNameByNaicsTyped[st];
        return naicsTwoChildTitles.flatMap((str, nu) => {
            naicsTwoCount += 1;
            const isParentTitle = str === naicsFourTitle;
            if (isParentTitle) {
                return [];
            }
            // TODO Weird logic
            if ((naicsTwoCount >= 4 || industryNaicsFourCodesLength <= 2) && (naicsTwoCount >= 8 || industryNaicsFourCodesLength >= 2)) {
                return [];
            }
            const href = industryTitleUrlRewrittenLookup[str];
            return [
                _jsx("a", Object.assign({ className: cx(classCombiner(styles, "link-with-underline")), href: href }, { children: str }), nu)
            ];
        });
    });
    const naicsFourTitleArray = industryNaicsFourCodes.map((st) => industryNameByNaicsTyped[st]);
    const naicsFourTitleArrayFiltered = filterOutUndefineds(naicsFourTitleArray);
    // Take three
    const naicsFourTitleArrayFilteredLimited = naicsFourTitleArrayFiltered.slice(0, 3);
    const contentNaicsFourCode = naicsFourTitleArrayFilteredLimited.map((st, nu) => {
        const naicsFourTitle = industryNaicsByTitleTyped[st];
        const href = industryTitleUrlRewrittenLookup[naicsFourTitle];
        return _jsx("a", Object.assign({ className: cx(classCombiner(styles, "link-with-underline")), href: href }, { children: st }), nu);
    });
    return contentNaicsTwoCode.length > 0 || contentNaicsFourCode.length > 0
        ?
            _jsxs("div", Object.assign({ className: cx("browse-component", classCombiner(styles, "contact-related-industries")) }, { children: [_jsxs("div", Object.assign({ className: cx("container", classCombiner(styles, "box-shadow-component"), classCombiner(styles, "contact-component-wrapper"), classCombiner(styles, "mobile-margin-lr")) }, { children: [_jsx("div", Object.assign({ className: cx("row") }, { children: _jsx("h3", Object.assign({ className: cx("col-xs-12", classCombiner(styles, "component-title")) }, { children: "Find Contacts in Related Industries" })) })), _jsx("hr", { className: cx(classCombiner(styles, "title-bottom-line")) }), _jsx("div", Object.assign({ className: cx("row", classCombiner(styles, "grid-wrap")) }, { children: _jsxs("div", Object.assign({ className: cx("col-xs-12", classCombiner(styles, "grid")) }, { children: [contentNaicsFourCode, contentNaicsTwoCode] })) }))] })), _jsx("p", { children: "*Contacts and Principals counts are estimates and may differ from the actual number of contacts available in D&B Hoovers." })] }))
        : _jsx(_Fragment, {});
};
const contactProfileRelatedIndustriesFragment = (renderableData) => renderIdentifierGeneric(ContactProfileRelatedIndustriesFragmentComponent, renderableData);
export { contactProfileRelatedIndustriesFragment };
